/** Strips control characters (null bytes, CR, LF, etc.) from user input */
export const sanitizeSearchQuery = (input: string): string =>
  // biome-ignore lint/suspicious/noControlCharactersInRegex: intentional sanitization
  input.replace(/[\x00-\x1F\x7F]/g, '').trim();
